import { INDUSTRY_TAXONOMY_DEMO_ID } from "app/pages/sales-intelligence/modules/industry/constants";
import { useActiveDemoId } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";

import type { SearchDemoMode } from "../types/dto";

/**
 * The marker the search API should receive for the active demo, or undefined outside one.
 *
 * Each demo names its own wire value here rather than the generic core exposing `DemoId` to the API, so a
 * future unrelated demo cannot start leaking its internal id into search requests.
 *
 * Read at the point of use — the demo store stays the single source of truth, exactly as the response side
 * already does in `useLeadsSearchTransformData`.
 *
 * Temporary — delete with the demo feature; every call site then fails to compile.
 */
export const useSearchDemoMode = (): SearchDemoMode | undefined =>
    useActiveDemoId() === INDUSTRY_TAXONOMY_DEMO_ID ? "industryTaxonomy" : undefined;
